import { useEffect, useState } from "react";
import Api from "lib/api/httpRequestHelper";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import EmailWithCopyAndSend from "components/Texts/EmailWithCopyAndSend";
import PhoneWithWhatsapp from "components/Texts/PhoneWithWhatsapp";
import { Close, WifiCalling3 } from "@mui/icons-material";
import LoadingData from "components/Loading/LoadingData";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";

export default function ContactCard({ storeId, setOpenedModal, setType }) {
  const [searching, setSearching] = useState(false);
  const [contact, setContact] = useState({});

  const snackbar = useSnackbar();

  const handleSearch = async () => {
    setSearching(true);
    try {
      const response = await Api.get(
        "store",
        "commercialstructure",
        "?idPessoaLoja=" + storeId + "&idMarca=" + 1,
        true
      );
      setContact(response.Result[0]);
    } catch (error) {
      snackbar.showMessage("Erro ao buscar informações de contatos:", {
        severity: "error",
      });
    } finally {
      setSearching(false);
    }
  };

  const contactInfo = [
    {
      label: "Telefone",
      value: <PhoneWithWhatsapp phone={contact.FonePrincipal} />,
    },
    {
      label: "Celular",
      value: <PhoneWithWhatsapp phone={contact.FoneCelular} />,
    },
    {
      label: "Telefone Recado",
      value: <PhoneWithWhatsapp phone={contact.FoneRecado} />,
    },
    {
      label: "E-mail Contato",
      value: <EmailWithCopyAndSend email={contact.EmailPrincipal} />,
    },
    {
      label: "E-mail NFe",
      value: <EmailWithCopyAndSend email={contact.EmailNFE} />,
    },
  ];

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <Dialog open onClose={() => setOpenedModal(null)} maxWidth={"md"}>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <WifiCalling3 style={{ marginRight: "12px" }} />
            Meus Contatos
          </Typography>
          <IconButton onClick={() => setOpenedModal(null)}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      {searching ? (
        <DialogContent>
          <LoadingData searching label="Buscando dados de contatos..." />
        </DialogContent>
      ) : (
        <DialogContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              {contactInfo.map(({ label, value }) => (
                <Typography key={label} variant="caption">
                  <strong>{label}:</strong> {value}
                </Typography>
              ))}
            </Grid>
          </Grid>
        </DialogContent>
      )}

      <DialogActions>
        <Button
          variant="outlined"
          style={{ marginTop: "1.5rem" }}
          onClick={() => setOpenedModal(null)}
        >
          Fechar
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ marginTop: "1.5rem" }}
          onClick={() => {
            setOpenedModal("ALTERACAO");
            setType("CONTACT");
          }}
        >
          Solicitar alteração
        </Button>
      </DialogActions>
    </Dialog>
  );
}
